class Pushbar {
    constructor(config = { overlay: true }) {
        this.activeBarStack = [];
        this.overlay = false;

        if (config.overlay) {
            this.overlay = document.querySelector('div.pushbar_overlay');
            // this.overlay = document.createElement('div');
            // this.overlay.classList.add('pushbar_overlay');
            // document.querySelector('body').appendChild(this.overlay);
        }

        this.bindEvents();
    }

    get opened() {
        const activeBar = this.activeBarStack.slice(-1)[0];
        return Boolean(activeBar instanceof HTMLElement && activeBar.classList.contains('opened'));
    }

    get activeBarId() {
        const activeBar = this.activeBarStack.slice(-1)[0];
        return activeBar instanceof HTMLElement && activeBar.getAttribute('data-pushbar-id');
    }

    static findElementById(pushbarId) {
        return document.querySelector(`[data-pushbar-id="${pushbarId}"]`);
    }

    handleOpenEvent(e) {
        e.preventDefault();
        const pushbarId = e.currentTarget.getAttribute('data-pushbar-target');
        if (pushbarId) {
            this.open(pushbarId);
        }
    }

    handleCloseEvent(e) {
        e.preventDefault();
        this.close();
    }

    handleKeyEvent(e) {
        if (this.opened && e.keyCode === 27) {
            this.close();
        }
    }

    bindEvents() {
        const triggers = document.querySelectorAll('[data-pushbar-target]');
        const closers = document.querySelectorAll('[data-pushbar-close]');
        const drawers = document.querySelectorAll('[data-pushbar-id]');

        drawers.forEach(drawer => {
            drawer.Pushbar = {
                open: () => this.open(drawer.getAttribute('data-pushbar-id')),
                close: () => this.close()
            };
        });

        triggers.forEach(trigger =>
            trigger.addEventListener('click', e => this.handleOpenEvent(e), false)
        );
        closers.forEach(closer =>
            closer.addEventListener('click', e => this.handleCloseEvent(e), false)
        );

        if (this.overlay) {
            this.overlay.addEventListener('click', e => this.handleCloseEvent(e), false);
        }

        document.addEventListener('keyup', e => this.handleKeyEvent(e));
    }

    open(pushbarId) {
        // Current bar is already opened
        if (String(pushbarId) === this.activeBarId && this.opened) {
            return;
        }

        // Get new pushbar target
        const pushbar = Pushbar.findElementById(pushbarId);

        const that = this;
        Object.defineProperty(pushbar, 'Pushbar', {
            value: {
                open: function () {
                    that.open(pushbarId);
                },
                close: function () {
                    that.close();
                },
                closeAll: function () {
                    that.closeAll();
                }
            }
        });

        if (!pushbar) return;

        pushbar.classList.add('opened');

        const Root = document.querySelector('html');
        Root.classList.add('pushbar_locked');

        this.activeBarStack.push({
            activeBarId: this.activeBarId,
            activeBar: pushbar
        });
    }

    close() {
        const activeBarStackItem = this.activeBarStack.pop();
        if (!activeBarStackItem) return;

        const { activeBar } = activeBarStackItem;
        if (!activeBar) return;

        activeBar.classList.remove('opened');

        if (this.activeBarStack.length === 0) {
            const Root = document.querySelector('html');
            Root.classList.remove('pushbar_locked');
            Root.removeAttribute('pushbar');
        }
    }

    closeAll() {
        while (this.activeBarStack.length > 0) {
            this.close();
        }
    }
}

export default Pushbar;
